export default {
  返回上一页: "返回上一页",
  密码规则说明: "请输入新的账号密码，密码须满足8-12位字符，包含数字和字母。",
  新密码: "新密码",
  密码必填提示: "8-12位字符，包含数字和字母",
  密码格式提示: "密码需8-12位，且包含字母和数字",
  确认密码: "确认密码",
  确认密码必填提示: "请再次输入密码",
  密码不一致提示: "两次输入的密码不一致",
  完成: "完成",
  帐号验证: "帐号验证",
  重置密码: "重置密码",
  安全通知已发送: "安全通知已发送至：",
  登录邮箱提示: "您的登录邮箱：",
  立即登录: "立即登录",
  邮箱验证说明: "请输入您的登录邮箱号，我们将发送安全验证码到您的邮箱。",
  无法访问邮箱说明: "如果您无法访问注册邮箱，请联系客服寻求人工帮助。",
  联系客服: "联系客服",
  员工工号: "员工工号",
  请输入工号: "请输入员工工号！",
};
